import {useContextState as useUserContext} from '../../../../../../context/user';
import {useContextState as useSubClientContext} from '../../../../../../context/sub-client';
import {useSalesmanContext} from '../../../../../../context/salesman';
import {Role} from '../../../../../../constants/enumerations';

export const useBalanceList = () => {
  const {profile} = useUserContext();

  const {
    fetchBalanceList: fetchSubClientBalanceListt,
    balances: subClientBalances,
    salesmanClient: subClientSalesmanCustomer,
  } = useSubClientContext();

  const {
    fetchBalanceList: fetchCustomerBalanceList,
    balances: customerBalances,
    client: salesmanCustomer,
  } = useSalesmanContext();

  const fetchBalanceList = async (): Promise<boolean> => {
    if (profile?.role === Role.salesman) {
      return fetchCustomerBalanceList();
    }
    return fetchSubClientBalanceListt();
  };

  const balanceList =
    profile?.role === Role.salesman ? customerBalances : subClientBalances;

  const customer =
    profile?.role === Role.salesman
      ? salesmanCustomer
      : subClientSalesmanCustomer;

  return {fetchBalanceList, balanceList, customer};
};
